import { render, staticRenderFns } from "./tableShiftDetail.vue?vue&type=template&id=4a0dba9a&scoped=true"
import script from "./tableShiftDetail.vue?vue&type=script&lang=js"
export * from "./tableShiftDetail.vue?vue&type=script&lang=js"
import style0 from "./tableShiftDetail.vue?vue&type=style&index=0&id=4a0dba9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0dba9a",
  null
  
)

export default component.exports